<template>
  <div :id="component_id" class="self-stretch pt-2 pb-6 inline-flex flex-col justify-start items-start gap-6">
    <!-- Navigation Tabs -->
    <div class="self-stretch pr-6 pt-3 pb-px border-b border-border-separator inline-flex justify-start items-start gap-10">
      <!-- External Messages Tab -->
      <div v-if="false" class="cursor-pointer inline-flex flex-col justify-start items-start gap-2 select-none" @click="active_tab = 'External'">
        <div class="inline-flex justify-start items-center gap-1">
          <div class="justify-start text-base font-semibold leading-5" :class="active_tab === 'External' ? 'text-text-link' : 'text-text-subtle'">{{ $t('settings.notifications.tabs.external') }}</div>
        </div>
        <div v-if="active_tab === 'External'" class="self-stretch h-0 outline outline-2 outline-offset-[-1px] outline-brand-outline"></div>
      </div>

      <!-- Internal Messages Tab -->
      <div class="cursor-pointer inline-flex flex-col justify-start items-start gap-2 select-none" @click="active_tab = 'Internal'">
        <div class="justify-start text-base font-semibold leading-5" :class="active_tab === 'Internal' ? 'text-text-link' : 'text-text-subtle'">{{ $t('settings.notifications.tabs.internal') }}</div>
        <div v-if="active_tab === 'Internal'" class="self-stretch h-0 outline outline-2 outline-offset-[-1px] outline-brand-outline"></div>
      </div>

      <!-- Rey Assistant Tab -->
      <div v-if="false" class="cursor-pointer inline-flex flex-col justify-start items-start gap-2 select-none" @click="active_tab = 'Rey'">
        <div class="inline-flex justify-start items-center gap-1">
          <div class="justify-start text-base font-semibold leading-5" :class="active_tab === 'Rey' ? 'text-text-link' : 'text-text-subtle'">{{ $t('settings.notifications.tabs.rey') }}</div>
        </div>
        <div v-if="active_tab === 'Rey'" class="self-stretch h-0 outline outline-2 outline-offset-[-1px] outline-brand-outline"></div>
      </div>
    </div>

    <!-- External Messages Content -->
    <div v-if="false" v-show="active_tab === 'External'" class="self-stretch">
      <div class="self-stretch inline-flex flex-col justify-start items-start gap-4">
        <!-- Search Box -->
        <div class="w-96 h-8 px-3 py-2 bg-surface-1 rounded-md outline outline-1 outline-offset-[-1px] outline-border-default inline-flex justify-between items-center">
          <div class="flex justify-start items-center gap-2.5 flex-1">
            <i class="ri-search-line text-text-subtle" />
            <input v-model="search_external" type="text" :placeholder="$t('settings.notifications.searchPlaceholder')" class="flex-1 text-text-default text-sm leading-4 tracking-tight bg-surface-1 border-none outline-none placeholder:text-text-subtle" />
          </div>
          <i class="ri-equalizer-line text-text-subtle cursor-pointer hover:text-text-default" />
        </div>
        
        <!-- Table Header -->
        <div class="sticky top-0 z-10 self-stretch h-8 px-2 bg-surface-2 rounded inline-flex justify-between items-center">
          <div class="w-40 text-text-subtle text-sm font-semibold leading-4 tracking-tight">{{ $t('settings.notifications.columns.eventType') }}</div>
          <div class="w-20 text-text-subtle text-sm font-semibold leading-4 tracking-tight">{{ $t('settings.notifications.columns.toolbar') }}</div>
          <div class="w-16 text-text-subtle text-sm font-semibold leading-4 tracking-tight">{{ $t('settings.notifications.columns.sound') }}</div>
          <div class="w-24 text-text-subtle text-sm font-semibold leading-4 tracking-tight">{{ $t('settings.notifications.columns.priority') }}</div>
          <div class="w-16 text-center text-text-subtle text-sm font-semibold leading-4 tracking-tight">{{ $t('settings.notifications.columns.email') }}</div>
          <div class="w-16 text-center text-text-subtle text-sm font-semibold leading-4 tracking-tight">{{ $t('settings.notifications.columns.text') }}</div>
          <div class="w-16 text-center text-text-subtle text-sm font-semibold leading-4 tracking-tight">{{ $t('settings.notifications.columns.push') }}</div>
        </div>

        <!-- External Notification Rows -->
        <div class="self-stretch flex flex-col justify-start items-start">
          <!-- Section: Customer Messages -->
          <div class="w-96 h-8 px-1.5 rounded-md inline-flex justify-start items-center gap-1.5">
            <div class="text-text-default text-sm font-semibold leading-4 tracking-tight">{{ $t('settings.notifications.sections.customerMessages') }}</div>
            <i class="ri-arrow-down-s-line text-text-subtle text-xs"></i>
          </div>
          
          <notification-row v-for="(row, idx) in external_customer_messages" :key="'ext-cust-' + idx" :label="$t('settings.notifications.events.' + row.key)" v-model:toolbar="row.toolbar" v-model:sound="row.sound"
                            v-model:priority="row.priority" v-model:email="row.email" v-model:text="row.text" v-model:push="row.push" :priority-options="priority_options" />
        </div>
      </div>
    </div>

    <!-- Internal Messages Content -->
    <div v-show="active_tab === 'Internal'" class="self-stretch">
      <div class="self-stretch inline-flex flex-col justify-start items-start gap-4">
        <!-- Search Box -->
        <div v-if="false" class="w-96 h-8 px-3 py-2 bg-surface-1 rounded-md outline outline-1 outline-offset-[-1px] outline-border-default inline-flex justify-between items-center">
          <div class="flex justify-start items-center gap-2.5 flex-1">
            <i class="ri-search-line text-text-subtle"></i>
            <input v-model="search_internal" type="text" :placeholder="$t('settings.notifications.searchPlaceholder')" class="flex-1 text-text-default text-sm leading-4 tracking-tight bg-surface-1 border-none outline-none placeholder:text-text-subtle" />
          </div>
          <i class="ri-equalizer-line text-text-subtle cursor-pointer hover:text-text-default"></i>
        </div>

        <!-- Table Header -->
        <div class="sticky top-0 z-10 self-stretch h-8 px-2 bg-surface-2 rounded inline-flex justify-between items-center">
          <div class="w-40 text-text-subtle text-sm font-semibold leading-4 tracking-tight">{{ $t('settings.notifications.columns.eventType') }}</div>
          <div class="w-20 text-text-subtle text-sm font-semibold leading-4 tracking-tight">{{ $t('settings.notifications.columns.toolbar') }}</div>
          <div class="w-16 text-text-subtle text-sm font-semibold leading-4 tracking-tight">{{ $t('settings.notifications.columns.sound') }}</div>
          <div class="w-24 text-text-subtle text-sm font-semibold leading-4 tracking-tight">{{ $t('settings.notifications.columns.priority') }}</div>
          <div class="w-16 text-center text-text-subtle text-sm font-semibold leading-4 tracking-tight">{{ $t('settings.notifications.columns.email') }}</div>
          <div class="w-16 text-center text-text-subtle text-sm font-semibold leading-4 tracking-tight">{{ $t('settings.notifications.columns.text') }}</div>
          <div class="w-16 text-center text-text-subtle text-sm font-semibold leading-4 tracking-tight">{{ $t('settings.notifications.columns.push') }}</div>
        </div>

        <!-- Direct Messages Section -->
        <div class="self-stretch flex flex-col justify-start items-start">
          <div class="w-96 h-8 px-1.5 rounded-md inline-flex justify-start items-center gap-1.5">
            <div class="text-text-default text-sm font-semibold leading-4 tracking-tight">{{ $t('settings.notifications.sections.directMessages') }}</div>
            <i v-if="false" class="ri-arrow-down-s-line text-text-subtle text-xs"></i>
          </div>
          
          <notification-row v-for="(row, idx) in internal_direct_messages" :key="'int-dm-' + idx" :label="$t('settings.notifications.events.' + row.key)" v-model:toolbar="row.toolbar" v-model:sound="row.sound"
                            v-model:priority="row.priority" v-model:email="row.email" v-model:text="row.text" v-model:push="row.push" :priority-options="priority_options" />
        </div>

        <!-- Threads Section -->
        <div v-if="false" class="self-stretch flex flex-col justify-start items-start">
          <div class="w-96 h-8 px-1.5 rounded-md inline-flex justify-start items-center gap-1.5">
            <div class="text-text-default text-sm font-semibold leading-4 tracking-tight">{{ $t('settings.notifications.sections.threads') }}</div>
            <i class="ri-arrow-down-s-line text-text-subtle text-xs"></i>
          </div>
          
          <notification-row v-for="(row, idx) in internal_threads" :key="'int-thread-' + idx" :label="$t('settings.notifications.events.' + row.key)" v-model:toolbar="row.toolbar" v-model:sound="row.sound"
                            v-model:priority="row.priority" v-model:email="row.email" v-model:text="row.text" v-model:push="row.push" :priority-options="priority_options" />
        </div>

        <!-- Channels Section -->
        <div v-if="false" class="self-stretch flex flex-col justify-start items-start">
          <div class="w-96 h-8 px-1.5 rounded-md inline-flex justify-start items-center gap-1.5">
            <div class="text-text-default text-sm font-semibold leading-4 tracking-tight">{{ $t('settings.notifications.sections.channels') }}</div>
            <i class="ri-arrow-up-s-line text-text-subtle text-xs"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- Rey Assistant Content -->
    <div v-if="false" v-show="active_tab === 'Rey'" class="self-stretch">
      <div class="self-stretch inline-flex flex-col justify-start items-start gap-4">
        <!-- Search Box -->
        <div class="w-96 h-8 px-3 py-2 bg-surface-1 rounded-md outline outline-1 outline-offset-[-1px] outline-border-default inline-flex justify-between items-center">
          <div class="flex justify-start items-center gap-2.5 flex-1">
            <i class="ri-search-line text-text-subtle"></i>
            <input v-model="search_rey" type="text" :placeholder="$t('settings.notifications.searchPlaceholder')" class="flex-1 text-text-default text-sm leading-4 tracking-tight bg-surface-1 border-none outline-none placeholder:text-text-subtle" />
          </div>
          <i class="ri-equalizer-line text-text-subtle cursor-pointer hover:text-text-default"></i>
        </div>

        <!-- Table Header -->
        <div class="sticky top-0 z-10 self-stretch h-8 px-2 bg-surface-2 rounded inline-flex justify-between items-center">
          <div class="w-40 text-text-subtle text-sm font-semibold leading-4 tracking-tight">{{ $t('settings.notifications.columns.eventType') }}</div>
          <div class="w-20 text-text-subtle text-sm font-semibold leading-4 tracking-tight">{{ $t('settings.notifications.columns.toolbar') }}</div>
          <div class="w-16 text-text-subtle text-sm font-semibold leading-4 tracking-tight">{{ $t('settings.notifications.columns.sound') }}</div>
          <div class="w-24 text-text-subtle text-sm font-semibold leading-4 tracking-tight">{{ $t('settings.notifications.columns.priority') }}</div>
          <div class="w-16 text-center text-text-subtle text-sm font-semibold leading-4 tracking-tight">{{ $t('settings.notifications.columns.email') }}</div>
          <div class="w-16 text-center text-text-subtle text-sm font-semibold leading-4 tracking-tight">{{ $t('settings.notifications.columns.text') }}</div>
          <div class="w-16 text-center text-text-subtle text-sm font-semibold leading-4 tracking-tight">{{ $t('settings.notifications.columns.push') }}</div>
        </div>

        <!-- Rey Notifications Section -->
        <div class="self-stretch flex flex-col justify-start items-start">
          <div class="w-96 h-8 px-1.5 rounded-md inline-flex justify-start items-center gap-1.5">
            <div class="text-text-default text-sm font-semibold leading-4 tracking-tight">{{ $t('settings.notifications.sections.reyNotifications') }}</div>
            <i class="ri-arrow-down-s-line text-text-subtle text-xs"></i>
          </div>
          
          <notification-row v-for="(row, idx) in rey_notifications" :key="'rey-' + idx" :label="$t('settings.notifications.events.' + row.key)" v-model:toolbar="row.toolbar" v-model:sound="row.sound"
            v-model:priority="row.priority" v-model:email="row.email" v-model:text="row.text" v-model:push="row.push" :priority-options="priority_options" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FusionCheckbox from '@components/UI/FusionCheckbox.vue';
import FusionSwitch from '@components/UI/FusionSwitch.vue';
import FusionPillDropdown from '@components/UI/FusionPillDropdown.vue';

// Inline NotificationRow component for cleaner template
const NotificationRow = {
  components: { FusionCheckbox, FusionSwitch, FusionPillDropdown },
  props: {
    label: { type: String, required: true },
    toolbar: { type: Boolean, default: true },
    sound: { type: Boolean, default: true },
    priority: { type: String, default: 'standard' },
    email: { type: Boolean, default: true },
    text: { type: Boolean, default: true },
    push: { type: Boolean, default: true },
    priorityOptions: { type: Array, required: true }
  },
  emits: ['update:toolbar', 'update:sound', 'update:priority', 'update:email', 'update:text', 'update:push'],
  template: `
    <div class="self-stretch h-12 px-2 py-4 bg-surface-1 border-b border-border-separator inline-flex justify-between items-center">
      <div class="w-40 flex justify-start items-center gap-2">
        <div class="w-40 text-text-default text-sm font-normal leading-4 tracking-tight">{{ label }}</div>
      </div>
      <div class="w-20 flex justify-start items-center">
        <fusion-checkbox :modelValue="toolbar" @update:modelValue="$emit('update:toolbar', $event)" />
      </div>
      <div class="w-16 flex justify-start items-center">
        <fusion-switch :modelValue="sound" @update:modelValue="$emit('update:sound', $event)" />
      </div>
      <div class="w-24 flex justify-start items-center">
        <fusion-pill-dropdown :modelValue="priority" @update:modelValue="$emit('update:priority', $event)" :options="priorityOptions" />
      </div>
      <div class="w-16 flex justify-center items-center">
        <fusion-checkbox :modelValue="email" @update:modelValue="$emit('update:email', $event)" />
      </div>
      <div class="w-16 flex justify-center items-center">
        <fusion-checkbox :modelValue="text" @update:modelValue="$emit('update:text', $event)" />
      </div>
      <div class="w-16 flex justify-center items-center">
        <fusion-checkbox :modelValue="push" @update:modelValue="$emit('update:push', $event)" />
      </div>
    </div>
  `
};

export default {
  components: {
    FusionCheckbox,
    FusionSwitch,
    FusionPillDropdown,
    NotificationRow
  },
  props: {
    settings: {
      type: Object,
      required: false,
      default: null
    },
  },
  data() {
    return {
      active_tab: 'Internal',
      search_external: '',
      search_internal: '',
      search_rey: '',
      
      // Notification rows carry a stable `key`; the display label is resolved in the template via
      // $t('settings.notifications.events.<key>'). Keeping the label out of these arrays matters:
      // has_changes JSON-compares them, so a locale-dependent label would mark the form dirty on a
      // language switch. priority_options is computed for the same reason.

      // External Messages notifications
      external_customer_messages: [
        { key: 'newMessages', toolbar: true, sound: true, priority: 'standard', email: true, text: true, push: true },
        { key: 'replies', toolbar: true, sound: true, priority: 'urgent', email: true, text: true, push: true },
      ],
      
      // Internal Messages - Direct Messages
      internal_direct_messages: [
        { key: 'newMessages', toolbar: true, sound: true, priority: 'standard', email: true, text: true, push: true },
        { key: 'replies', toolbar: true, sound: true, priority: 'urgent', email: true, text: true, push: true },
        { key: 'likesAndReactions', toolbar: true, sound: true, priority: 'urgent', email: true, text: true, push: true },
      ],
      
      // Internal Messages - Threads
      internal_threads: [
        { key: 'addedToNewThread', toolbar: true, sound: true, priority: 'standard', email: true, text: true, push: true },
        { key: 'threadMentions', toolbar: true, sound: true, priority: 'urgent', email: true, text: true, push: true },
        { key: 'threadMessages', toolbar: true, sound: true, priority: 'urgent', email: true, text: true, push: true },
        { key: 'reyAiThreadInsight', toolbar: true, sound: true, priority: 'urgent', email: true, text: true, push: true },
        { key: 'likesAndReactions', toolbar: true, sound: true, priority: 'urgent', email: true, text: true, push: true },
      ],
      
      // Rey Assistant notifications
      rey_notifications: [
        { key: 'recommendations', toolbar: true, sound: true, priority: 'standard', email: true, text: false, push: true },
        { key: 'dailyUpdate', toolbar: true, sound: false, priority: 'low', email: true, text: false, push: false },
        { key: 'taskReminders', toolbar: true, sound: true, priority: 'urgent', email: true, text: true, push: true },
        { key: 'aiInsights', toolbar: true, sound: false, priority: 'standard', email: false, text: false, push: true },
      ],
      
      // Track original values for change detection
      original_values: {},
    }
  },
  created() {
    this.loadFromSettings();
  },
  computed: {
    component_key() {
      return this.$attrs.key ? this.$attrs.key : ('notifications_' + Date.now());
    },
    component_id() {
      return this.component_key + '_container';
    },
    // Localized dropdown options. Values stay in the backend's format — only labels are localized.
    priority_options() {
      return [
        { label: this.$t('settings.notifications.priorities.standard'), value: 'standard' },
        { label: this.$t('settings.notifications.priorities.urgent'), value: 'urgent' },
        { label: this.$t('settings.notifications.priorities.low'), value: 'low' },
      ];
    },
    // Build patch object with only changed values
    settings_patch() {
      const patch = {};
      // TODO: Map UI fields to backend keys once backend schema is confirmed
      // Currently the UI structure doesn't directly map to the backend's category/channel format
      return patch;
    },
    has_changes() {
      // For now, detect changes by comparing stringified arrays
      const current = JSON.stringify({
        external_customer_messages: this.external_customer_messages,
        internal_direct_messages: this.internal_direct_messages,
        internal_threads: this.internal_threads,
        rey_notifications: this.rey_notifications,
      });
      const original = JSON.stringify(this.original_values);
      return current !== original;
    },
  },
  watch: {
    has_changes: {
      handler(newVal) {
        this.$emit('changes', newVal);
      },
      immediate: true
    }
  },
  methods: {
    loadFromSettings() {
      // TODO: Load notification settings from backend once UI mapping is confirmed
      // Store original values for change detection
      this.original_values = {
        external_customer_messages: JSON.parse(JSON.stringify(this.external_customer_messages)),
        internal_direct_messages: JSON.parse(JSON.stringify(this.internal_direct_messages)),
        internal_threads: JSON.parse(JSON.stringify(this.internal_threads)),
        rey_notifications: JSON.parse(JSON.stringify(this.rey_notifications)),
      };
    },
    save() {
      // If there are changes, emit them
      // Since we don't have backend mapping yet, we'll emit a placeholder
      // to indicate save was attempted with changes
      if (this.has_changes) {
        // TODO: Build proper patch object when backend mapping is confirmed
        // For now, emit a minimal patch to trigger the save flow
        const patch = {
          // Placeholder - real implementation would map UI fields to backend keys
          'Notifications.LastUpdated': new Date().toISOString()
        };
        this.$emit('save', patch);
      } else {
        // No changes, just close
        this.$emit('cancel');
      }
    },
    cancel() {
      this.$emit('cancel');
    },
  },
}
</script>
